import script from "./ObjectiveChartTableColorMark.vue?vue&type=script&lang=js"
export * from "./ObjectiveChartTableColorMark.vue?vue&type=script&lang=js"

import "./ObjectiveChartTableColorMark.vue?vue&type=style&index=0&id=168634d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-168634d8"]])

export default __exports__